class AccordionController extends HTMLElement {
    static get observedAttributes() {
        return ['active-index']
    }

    connectedCallback() {
        this.initClickListener()
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'active-index') {
            if (oldValue) {
                this.querySelector(`.js-accordion-trigger[data-index="${oldValue}"]`)?.classList.remove('active') 
            }
            if (newValue) {
                const activeAccordion = this.querySelector(`.js-accordion-trigger[data-index="${newValue}"]`)
                if (activeAccordion) {
                    activeAccordion?.classList.add('active')
                    if (this.accordionCount > 1) {
                        setTimeout(() => {
                            activeAccordion.scrollIntoView({behavior: "smooth"})
                        }, 250)
                    }
                }
            }
        }
    }

    constructor() {
        super();
        this.accordionCount = this.querySelectorAll('.js-accordion-trigger')?.length 
    }

    initClickListener() { 
        this.addEventListener('click', this.handleClick.bind(this))
    }

    handleClick(evt) {
        this.target = evt.target
        if (this.target.classList.contains('js-accordion-trigger')) { 
            if (this.target.dataset.index == this.activeIndex) {
                this.activeIndex = null
            } else {
                this.activeIndex = this.target.dataset.index
            }
        }
    }

    get activeIndex() {
        const value = this.getAttribute('active-index')
        return value !== null ? parseInt(value, 10) : null
    } 
    set activeIndex(index) {
        if (index === null || index === undefined) {
            this.removeAttribute('active-index')
        } else {
            this.setAttribute('active-index', index)
        }
    }
}

!customElements.get('accordion-controller') && customElements.define('accordion-controller', AccordionController)

class PositionsController extends AccordionController {  
    static get observedAttributes() {
        return [
            ...super.observedAttributes,  
            'form-status',               
        ]
    } 
    
    attributeChangedCallback(name, oldValue, newValue) { 
        super.attributeChangedCallback(name, oldValue, newValue)
        
        if (name === 'form-status') {
            if (newValue === 'submitting') { 
                this.submitTrigger.classList.add('submitting')
                this.submitTrigger.disabled = true
            } else if (newValue === 'success') { 
                this.statusDisplay.classList.remove('error')
                this.statusDisplay.classList.add('success')
                this.statusDisplay.textContent = this.strings.success
                this.submitTrigger.remove()
            } else if (newValue === 'error') {
                this.statusDisplay.classList.add('error')
                this.statusDisplay.classList.remove('success')
                this.submitTrigger.classList.remove('submitting')
                this.statusDisplay.textContent = this.errorMessage
                this.submitTrigger.disabled = false
            } else if (!newValue) {
                this.clearErrors()
            }
        }
    }

    constructor() {
        super();
        (!this.strings) && (this.strings = JSON.parse(this.querySelector('#PositionsControllerStrings').textContent))
        this.formWrapper = this.querySelector('.positions-form-wrapper')
        this.form = this.formWrapper.querySelector('form')
        this.submitTrigger = this.form?.querySelector('.js-submit-application-form')
        this.dropdown = this.querySelector('dropdown-input')
        this.statusDisplay = this.querySelector('.status-display')
        this.fileSizeLimit = 5 * 1024 * 1024
    }

    handleClick(evt) {
        super.handleClick(evt)

        if (this.target.classList.contains('js-application-setup-trigger')) {
            this.formWrapper.scrollIntoView({behavior: "smooth"})
            this.form.querySelector('input').focus()
            this.dropdown.currentValue = this.target.dataset.value 
        } else if (this.target.classList.contains('js-submit-application-form')) {
            evt.preventDefault()
            this.onFormSubmit()
        }
    } 

    clearErrors() {
        this.errorMessage = ''
        this.statusDisplay.classList.remove('error')
        this.querySelectorAll('input, textarea, .js-dropdown-trigger').forEach(input => {
            input.classList.remove('input-error')
        })
    }

    validateForm(form) { 
        let valid = true;
        form.querySelectorAll('input, textarea').forEach(input => { 
            if (input.required && (!input.value || input.value?.length === 0)) {
                if (valid) valid = false;
                if (input.type == 'hidden') {
                    input.closest('dropdown-input').querySelector('.js-dropdown-trigger').classList.add('input-error')
                } else {
                    input.classList.add('input-error')
                }  
            }
            
            if (input.type == 'file') {
                const file = input.files[0]
                
                if (file?.size > this.fileSizeLimit) {
                    if (valid) valid = false
                    this.errorMessage = this.strings.errors.invalid_file
                } else if (!file) {
                    this.errorMessage = this.strings.errors.invalid_input
                }
            }
        })

        if (!valid) { 
            if (!this.errorMessage) this.errorMessage = this.strings.errors.invalid_input
            this.formStatus = 'error'
        } else {
            this.formStatus = null
            this.errorMessage = null
        }
        
        return valid
    }

    async onFormSubmit() {
        const valid = this.validateForm(this.form)
        if (!valid) return; 
        this.clearErrors()
        const formData = new FormData(this.form)
        this.formStatus = 'submitting'

        try {
            const response = await fetch('/apps/service-gateway/applications', {
                method: 'POST', 
                body: formData,
            })
            
            if (!response.ok) {
                throw new Error(`Request failed with status ${response.status}`)
            }

            const data = await response.json()
            
            if (data?.error) {
                this.errorMessage = data.error + '.'
                this.formStatus = 'error'
            } else {
                console.log('Form submitted successfully:', data)
                this.formStatus = 'success'
            }
        } catch (error) {
            console.error('Error submitting form:', error)
            this.errorMessage = this.strings.errors.network_error
            this.formStatus = 'error'
        }
    }


    get formStatus() {
        return this.getAttribute('form-status') || null
    }

    set formStatus(value) {
        if (value === null || value === undefined) {
        this.removeAttribute('form-status')
        } else {
        this.setAttribute('form-status', value)
        }
    } 
}

!customElements.get('positions-controller') && customElements.define('positions-controller', PositionsController)